export const brandAffiliate = {
  en_us: {
    salesPerformancePlan:
      'https://www.nuskin.com/content/dam/office/n_america/shared/en/business_materials/sales-performance-plan-us.pdf',
    privacyNotice:
      'https://www.nuskin.com/content/nuskin/en_US/corporate/privacy.html',
    refundPolicy:
      'https://www.nuskin.com/content/dam/account/north-america/US/en/nuskin_refund_policy.pdf',
    salesCompensationSummary:
      'https://www.nuskin.com/content/dam/office/n_america/US/en/business_materials/distearnings.pdf',
    brandAffiliateAgreement:
      'https://www.nuskin.com/content/dam/office/n_america/US/en/business_materials/brand-affiliate-agreement.pdf',
    policiesAndProcedures:
      'https://www.nuskin.com/content/dam/office/n_america/US/en/business_materials/Policies_Proced_US.pdf',
    smsAgreement:
      'https://www.nuskin.com/content/dam/account/north-america/US/en/SMS-Terms-of-Service_en_US.pdf',
    enjoyTermsAndConsitions:
      'https://www.nuskin.com/content/dam/apps/loyalty/en_US/TermsAndConditions.pdf',
    faq: 'https://www.nuskin.com/content/nuskin/en_US/loyalty/faq.html',
  },
  es_us: {
    salesPerformancePlan:
      'https://www.nuskin.com/content/dam/office/n_america/shared/en/business_materials/sales-performance-plan-us.pdf',
    privacyNotice:
      'https://www.nuskin.com/content/nuskin/en_US/corporate/privacy.html',
    refundPolicy:
      'https://www.nuskin.com/content/dam/account/north-america/US/en/nuskin_refund_policy.pdf',
    salesCompensationSummary:
      'https://www.nuskin.com/content/dam/office/n_america/US/en/business_materials/distearnings.pdf',
    brandAffiliateAgreement:
      'https://www.nuskin.com/content/dam/office/n_america/US/en/business_materials/brand-affiliate-agreement.pdf',
    policiesAndProcedures:
      'https://www.nuskin.com/content/dam/office/n_america/US/en/business_materials/Policies_Proced_US.pdf',
    smsAgreement:
      'https://www.nuskin.com/content/dam/account/north-america/US/en/SMS-Terms-of-Service_en_US.pdf',
    enjoyTermsAndConsitions:
      'https://www.nuskin.com/content/dam/apps/loyalty/es_US/TermsAndConditions.pdf',
    faq: 'https://www.nuskin.com/content/nuskin/es_US/loyalty/faq.html',
  },
  zh_us: {
    salesPerformancePlan:
      'https://www.nuskin.com/content/dam/office/n_america/shared/en/business_materials/sales-performance-plan-us.pdf',
    privacyNotice:
      'https://www.nuskin.com/content/nuskin/en_US/corporate/privacy.html',
    refundPolicy:
      'https://www.nuskin.com/content/dam/account/north-america/US/en/nuskin_refund_policy.pdf',
    salesCompensationSummary:
      'https://www.nuskin.com/content/dam/office/n_america/US/en/business_materials/distearnings.pdf',
    brandAffiliateAgreement:
      'https://www.nuskin.com/content/dam/office/n_america/US/en/business_materials/brand-affiliate-agreement.pdf',
    policiesAndProcedures:
      'https://www.nuskin.com/content/dam/office/n_america/US/en/business_materials/Policies_Proced_US.pdf',
    smsAgreement:
      'https://www.nuskin.com/content/dam/account/north-america/US/en/SMS-Terms-of-Service_en_US.pdf',
    enjoyTermsAndConsitions:
      'https://www.nuskin.com/content/dam/apps/loyalty/zh_US/TermsAndConditions.pdf',
    faq: 'https://www.nuskin.com/content/nuskin/zh_US/loyalty/faq.html',
  },
  vi_us: {
    salesPerformancePlan:
      'https://www.nuskin.com/content/dam/office/n_america/shared/en/business_materials/sales-performance-plan-us.pdf',
    privacyNotice:
      'https://www.nuskin.com/content/nuskin/en_US/corporate/privacy.html',
    refundPolicy:
      'https://www.nuskin.com/content/dam/account/north-america/US/en/nuskin_refund_policy.pdf',
    salesCompensationSummary:
      'https://www.nuskin.com/content/dam/office/n_america/US/en/business_materials/distearnings.pdf',
    brandAffiliateAgreement:
      'https://www.nuskin.com/content/dam/office/n_america/US/en/business_materials/brand-affiliate-agreement.pdf',
    policiesAndProcedures:
      'https://www.nuskin.com/content/dam/office/n_america/US/en/business_materials/Policies_Proced_US.pdf',
    smsAgreement:
      'https://www.nuskin.com/content/dam/account/north-america/US/en/SMS-Terms-of-Service_en_US.pdf',
    enjoyTermsAndConsitions:
      'https://www.nuskin.com/content/dam/apps/loyalty/vi_US/TermsAndConditions.pdf',
    faq: 'https://www.nuskin.com/content/nuskin/vi_US/loyalty/faq.htm',
  },
  en_ca: {
    salesPerformancePlan:
      'https://www.nuskin.com/content/dam/office/n_america/shared/en/business_materials/sales-performance-plan-ca.pdf',
    privacyNotice:
      'https://www.nuskin.com/content/nuskin/en_CA/corporate/privacy.html',
    refundPolicy:
      'https://www.nuskin.com/content/dam/global/library/pdf/nuskin_refund_policy.pdf',
    salesCompensationSummary:
      'https://www.nuskin.com/content/dam/office/n_america/US/en/business_materials/distearnings.pdf',
    brandAffiliateAgreement:
      'https://www.nuskin.com/content/dam/office/n_america/CA/en/business_materials/brand-affiliate-agreement-ca.pdf',
    policiesAndProcedures:
      'https://www.nuskin.com/content/dam/office/n_america/CA/en/business_materials/Policies_Proced_CA.pdf',
    smsAgreement:
      'https://www.nuskin.com/content/dam/account/north-america/CA/en/CA_SMS-Terms-of-Service.pdf',
    enjoyTermsAndConsitions:
      'https://www.nuskin.com/content/dam/apps/loyalty/en_CA/TermsAndConditions.pdf',
    faq: 'https://www.nuskin.com/content/nuskin/en_CA/loyalty/faq.html',
  },
  fr_ca: {
    salesPerformancePlan:
      'https://www.nuskin.com/content/dam/office/n_america/shared/en/business_materials/sales-performance-plan-ca.pdf',
    privacyNotice:
      'https://www.nuskin.com/content/nuskin/fr_CA/corporate/privacy.html',
    refundPolicy:
      'https://www.nuskin.com/content/dam/global/library/pdf/nuskin_refund_policy.pdf',
    salesCompensationSummary:
      'https://www.nuskin.com/content/dam/office/n_america/US/en/business_materials/distearnings.pdf',
    brandAffiliateAgreement:
      'https://www.nuskin.com/content/dam/office/n_america/CA/en/business_materials/brand-affiliate-agreement-ca.pdf',
    policiesAndProcedures:
      'https://www.nuskin.com/content/dam/office/n_america/CA/en/business_materials/Policies_Proced_CA.pdf',
    smsAgreement:
      'https://www.nuskin.com/content/dam/account/north-america/CA/en/CA_SMS-Terms-of-Service.pdf',
    enjoyTermsAndConsitions:
      'https://www.nuskin.com/content/dam/apps/loyalty/fr_CA/TermsAndConditions.pdf',
    faq: 'https://www.nuskin.com/content/nuskin/fr_CA/loyalty/faq.html',
  },
  zh_ca: {
    salesPerformancePlan:
      'https://www.nuskin.com/content/dam/office/n_america/shared/en/business_materials/sales-performance-plan-us.pdf',
    privacyNotice:
      'https://www.nuskin.com/content/nuskin/en_US/corporate/privacy.html',
    refundPolicy:
      'https://www.nuskin.com/content/dam/global/library/pdf/nuskin_refund_policy.pdf',
    salesCompensationSummary:
      'https://www.nuskin.com/content/dam/office/n_america/US/en/business_materials/distearnings.pdf',
    brandAffiliateAgreement:
      'https://www.nuskin.com/content/dam/office/n_america/CA/en/business_materials/brand-affiliate-agreement-ca.pdf',
    policiesAndProcedures:
      'https://www.nuskin.com/content/dam/office/n_america/CA/en/business_materials/Policies_Proced_CA.pdf',
    smsAgreement:
      'https://www.nuskin.com/content/dam/account/north-america/CA/en/CA_SMS-Terms-of-Service.pdf',
    enjoyTermsAndConsitions:
      'https://www.nuskin.com/content/dam/apps/loyalty/zh_CA/TermsAndConditions.pdf',
    faq: 'https://www.nuskin.com/content/nuskin/zh_CA/loyalty/faq.html',
  },
  en_au: {
    smsAgreement:
      'https://media.nuskin.com/m/0560501de5ad3c0a/original/sms-agreement-au.pdf',
  },
}

export const retailCustomer = {
  en_us: {
    refundPolicy:
      'https://www.nuskin.com/content/dam/account/north-america/US/en/nuskin_refund_policy.pdf',
    privacyNotice:
      'https://www.nuskin.com/content/nuskin/en_US/corporate/privacy.html',
    termsOfUse: '/content/nuskin/en_US/corporate/terms.html',
    smsAgreement:
      'https://www.nuskin.com/content/dam/account/north-america/US/en/SMS-Terms-of-Service_en_US.pdf',
    enjoyTermsAndConsitions:
      'https://www.nuskin.com/content/dam/apps/loyalty/en_US/TermsAndConditions.pdf',
    subscriptionAgreement:
      'https://nuskin.com/content/dam/account/US/subscription-terms-and-conditions-en-US-20240904.pdf',
    faq: 'https://www.nuskin.com/content/nuskin/en_US/loyalty/faq.html',
    storedCredentialsConsentAgreement:
      'https://media.nuskin.com/m/2155b8a224aeb6e4/original/Stored-Credentials-US-06-2023.pdf',
    klarnaShoppingServiceLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/0/en_us/user',
    klarnaPrivacyPolicyLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/0/en_us/privacy',
  },
  es_us: {
    refundPolicy:
      'https://www.nuskin.com/content/dam/account/north-america/US/en/nuskin_refund_policy.pdf',
    privacyNotice:
      'https://www.nuskin.com/content/nuskin/en_US/corporate/privacy.html',
    termsOfUse: '/content/nuskin/es_US/corporate/terms.html',
    smsAgreement:
      'https://www.nuskin.com/content/dam/account/north-america/US/en/SMS-Terms-of-Service_en_US.pdf',
    enjoyTermsAndConsitions:
      'https://www.nuskin.com/content/dam/apps/loyalty/es_US/TermsAndConditions.pdf',
    subscriptionAgreement:
      'https://nuskin.com/dam/account/US/subscription-terms-and-conditions-es-US-20240904.pdf',
    faq: 'https://www.nuskin.com/content/nuskin/es_US/loyalty/faq.html',
    storedCredentialsConsentAgreement:
      'https://media.nuskin.com/m/79ece3820482a7cd/original/Stored-Credentials-US-06-2023-ES.pdf',
    klarnaShoppingServiceLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/0/es_us/user',
    klarnaPrivacyPolicyLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/0/es_us/privacy',
  },
  zh_us: {
    refundPolicy:
      'https://www.nuskin.com/content/dam/account/north-america/US/en/nuskin_refund_policy.pdf',
    privacyNotice:
      'https://www.nuskin.com/content/nuskin/en_US/corporate/privacy.html',
    termsOfUse: '/content/dam/account/north-america/US/en/Terms-of-Use_en.html',
    smsAgreement:
      'https://www.nuskin.com/content/dam/account/north-america/US/en/SMS-Terms-of-Service_en_US.pdf',
    enjoyTermsAndConsitions:
      'https://www.nuskin.com/content/dam/apps/loyalty/zh_US/TermsAndConditions.pdf',
    subscriptionAgreement:
      'https://nuskin.com/content/dam/account/US/subscription-terms-and-conditions-en-US-20240904.pdf',
    faq: 'https://www.nuskin.com/content/nuskin/zh_US/loyalty/faq.html',
    storedCredentialsConsentAgreement:
      'https://media.nuskin.com/m/376745116711eadb/original/Stored-Credentials-US-06-2023-ZH.pdf',
    klarnaShoppingServiceLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/0/en_us/user',
    klarnaPrivacyPolicyLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/0/en_us/privacy',
  },
  vi_us: {
    refundPolicy:
      'https://www.nuskin.com/content/dam/account/north-america/US/en/nuskin_refund_policy.pdf',
    privacyNotice:
      'https://www.nuskin.com/content/nuskin/en_US/corporate/privacy.html',
    termsOfUse: '/content/dam/account/north-america/US/en/Terms-of-Use_en.html',
    smsAgreement:
      'https://www.nuskin.com/content/dam/account/north-america/US/en/SMS-Terms-of-Service_en_US.pdf',
    enjoyTermsAndConsitions:
      'https://www.nuskin.com/content/dam/apps/loyalty/vi_US/TermsAndConditions.pdf',
    subscriptionAgreement:
      'https://nuskin.com/content/dam/account/US/subscription-terms-and-conditions-en-US-20240904.pdf',
    faq: 'https://www.nuskin.com/content/nuskin/vi_US/loyalty/faq.html',
    storedCredentialsConsentAgreement:
      'https://media.nuskin.com/m/bb1ea9c4fe25cdd/original/Stored-Credentials-US-06-2023-VI.pdf',
    klarnaShoppingServiceLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/0/en_us/user',
    klarnaPrivacyPolicyLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/0/en_us/privacy',
  },
  en_ca: {
    refundPolicy:
      'https://www.nuskin.com/content/dam/global/library/pdf/nuskin_refund_policy.pdf',
    privacyNotice:
      'https://www.nuskin.com/content/nuskin/en_CA/corporate/privacy.html',
    termsOfUse: '/content/nuskin/en_CA/corporate/terms.html',
    memberAgreement:
      'https://www.nuskin.com/content/dam/account/north-america/CA/en/member-agreement-ca.pdf',
    smsAgreement:
      'https://www.nuskin.com/content/dam/account/north-america/CA/en/CA_SMS-Terms-of-Service.pdf',
    enjoyTermsAndConsitions:
      'https://www.nuskin.com/content/dam/apps/loyalty/en_CA/TermsAndConditions.pdf',
    subscriptionAgreement:
      'https://nuskin.com/content/dam/account/CA/subscription-terms-and-conditions-en-CA-20240904.pdf',
    faq: 'https://www.nuskin.com/content/nuskin/en_CA/loyalty/faq.html',
    storedCredentialsConsentAgreement:
      'https://media.nuskin.com/m/66613768d6366fa2/original/Stored-Credentials-CA-06-2023.pdf',
    klarnaShoppingServiceLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/0/en_ca/user',
    klarnaPrivacyPolicyLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/0/en_ca/privacy',
  },
  fr_ca: {
    refundPolicy:
      'https://www.nuskin.com/content/dam/global/library/pdf/nuskin_refund_policy.pdf',
    privacyNotice:
      'https://www.nuskin.com/content/nuskin/fr_CA/corporate/privacy.html',
    termsOfUse: '/content/nuskin/fr_CA/corporate/terms.html',
    memberAgreement:
      'https://www.nuskin.com/content/dam/account/north-america/CA/en/member-agreement-ca.pdf',
    smsAgreement:
      'https://www.nuskin.com/content/dam/account/north-america/CA/en/CA_SMS-Terms-of-Service.pdf',
    enjoyTermsAndConsitions:
      'https://www.nuskin.com/content/dam/apps/loyalty/fr_CA/TermsAndConditions.pdf',
    subscriptionAgreement:
      'https://nuskin.com/content/dam/account/CA/subscription-terms-and-conditions-fr-CA-20240904.pdf',
    faq: 'https://www.nuskin.com/content/nuskin/fr_CA/loyalty/faq.html',
    storedCredentialsConsentAgreement:
      'https://media.nuskin.com/m/64700eceebca9e12/original/Stored-Credentials-CA-06-2023-FR.pdf',
    klarnaShoppingServiceLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/0/fr_ca/user',
    klarnaPrivacyPolicyLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/0/fr_ca/privacy',
  },
  zh_ca: {
    refundPolicy:
      'https://www.nuskin.com/content/dam/global/library/pdf/nuskin_refund_policy.pdf',
    privacyNotice:
      'https://www.nuskin.com/content/nuskin/en_US/corporate/privacy.html',
    termsOfUse: '/content/nuskin/en_CA/corporate/terms.html',
    memberAgreement:
      'https://www.nuskin.com/content/dam/account/north-america/CA/en/member-agreement-ca.pdf',
    smsAgreement:
      'https://www.nuskin.com/content/dam/account/north-america/CA/en/CA_SMS-Terms-of-Service.pdf',
    enjoyTermsAndConsitions:
      'https://www.nuskin.com/content/dam/apps/loyalty/zh_CA/TermsAndConditions.pdf',
    subscriptionAgreement:
      'https://nuskin.com/content/dam/account/CA/subscription-terms-and-conditions-en-CA-20240904.pdf',
    faq: 'https://www.nuskin.com/content/nuskin/zh_CA/loyalty/faq.html',
    storedCredentialsConsentAgreement:
      'https://media.nuskin.com/m/23069f06dd1b76c7/original/Stored-Credentials-CA-06-2023-ZH.pdf',
    klarnaShoppingServiceLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/0/en_ca/user',
    klarnaPrivacyPolicyLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/0/en_ca/privacy',
  },
  es_ar: {
    storedCredentialsConsentAgreement:
      'https://media.nuskin.com/m/79ece3820482a7cd/original/Stored-Credentials-AR-06-2023-ES.pdf',
    smsAgreement:
      'https://www.nuskin.com/content/dam/account/north-america/US/en/SMS-Terms-of-Service_en_US.pdf',
  },
  es_cl: {
    storedCredentialsConsentAgreement:
      'https://media.nuskin.com/m/79ece3820482a7cd/original/Stored-Credentials-CL-06-2023-ES.pdf',
    smsAgreement:
      'https://www.nuskin.com/content/dam/account/north-america/US/en/SMS-Terms-of-Service_en_US.pdf',
  },
  es_co: {
    storedCredentialsConsentAgreement:
      'https://media.nuskin.com/m/79ece3820482a7cd/original/Stored-Credentials-CO-06-2023-ES.pdf',
    smsAgreement:
      'https://www.nuskin.com/content/dam/account/north-america/US/en/SMS-Terms-of-Service_en_US.pdf',
  },
  es_pe: {
    storedCredentialsConsentAgreement:
      'https://media.nuskin.com/m/79ece3820482a7cd/original/Stored-Credentials-PE-06-2023-ES.pdf',
    smsAgreement:
      'https://www.nuskin.com/content/dam/account/north-america/US/en/SMS-Terms-of-Service_en_US.pdf',
  },
  es_mx: {
    storedCredentialsConsentAgreement:
      'https://media.nuskin.com/m/79ece3820482a7cd/original/Stored-Credentials-MX-06-2023-ES.pdf',
    smsAgreement:
      'https://www.nuskin.com/content/dam/account/north-america/US/en/SMS-Terms-of-Service_en_US.pdf',
  },
  cs_cz: {
    storedCredentialsConsentAgreement:
      'https://media.nuskin.com/asset/8967883a-436c-4679-9f6e-ce8da63dc72c/Stored-credentials_EUA_cs.pdf',
    klarnaShoppingServiceLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/cs-cz/user',
    klarnaPrivacyPolicyLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/cs-cz/privacy',
  },
  da_dk: {
    storedCredentialsConsentAgreement:
      'https://media.nuskin.com/asset/8ba0b735-f3d3-4c95-a62a-9ba6c8d355fa/Stored-credentials_EUA_da.pdf',
    klarnaShoppingServiceLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/da-dk/user',
    klarnaPrivacyPolicyLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/da-dk/privacy',
  },
  de_at: {
    storedCredentialsConsentAgreement:
      'https://media.nuskin.com/asset/efac3d71-ce7f-4d44-bc5f-cf36e902d4f7/Stored-credentials_EUA_de.pdf',
    klarnaShoppingServiceLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/de-at/user',
    klarnaPrivacyPolicyLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/de-at/privacy',
  },
  de_be: {
    storedCredentialsConsentAgreement:
      'https://media.nuskin.com/asset/efac3d71-ce7f-4d44-bc5f-cf36e902d4f7/Stored-credentials_EUA_de.pdf',
  },
  de_ch: {
    storedCredentialsConsentAgreement:
      'https://media.nuskin.com/asset/efac3d71-ce7f-4d44-bc5f-cf36e902d4f7/Stored-credentials_EUA_de.pdf',
    klarnaShoppingServiceLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/de-ch/user',
    klarnaPrivacyPolicyLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/de-ch/privacy',
  },
  de_de: {
    storedCredentialsConsentAgreement:
      'https://media.nuskin.com/asset/efac3d71-ce7f-4d44-bc5f-cf36e902d4f7/Stored-credentials_EUA_de.pdf',
    klarnaShoppingServiceLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/de-de/user',
    klarnaPrivacyPolicyLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/de-de/privacy',
  },
  de_lu: {
    storedCredentialsConsentAgreement:
      'https://media.nuskin.com/asset/efac3d71-ce7f-4d44-bc5f-cf36e902d4f7/Stored-credentials_EUA_de.pdf',
    // Klarna has no de-lu page; Luxembourg German redirects to the French (fr-lu) terms
    klarnaShoppingServiceLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/fr-lu/user',
    klarnaPrivacyPolicyLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/fr-lu/privacy',
  },
  en_at: {
    storedCredentialsConsentAgreement:
      'https://media.nuskin.com/asset/d5c5ffb7-873b-4ee9-81e8-fc004da5386f/Stored-credentials_EUA_en.pdf',
    klarnaShoppingServiceLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/en-at/user',
    klarnaPrivacyPolicyLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/en-at/privacy',
  },
  en_be: {
    storedCredentialsConsentAgreement:
      'https://media.nuskin.com/asset/d5c5ffb7-873b-4ee9-81e8-fc004da5386f/Stored-credentials_EUA_en.pdf',
    klarnaShoppingServiceLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/en-be/user',
    klarnaPrivacyPolicyLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/en-be/privacy',
  },
  en_ch: {
    storedCredentialsConsentAgreement:
      'https://media.nuskin.com/asset/d5c5ffb7-873b-4ee9-81e8-fc004da5386f/Stored-credentials_EUA_en.pdf',
    klarnaShoppingServiceLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/en-ch/user',
    klarnaPrivacyPolicyLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/en-ch/privacy',
  },
  en_cz: {
    storedCredentialsConsentAgreement:
      'https://media.nuskin.com/asset/d5c5ffb7-873b-4ee9-81e8-fc004da5386f/Stored-credentials_EUA_en.pdf',
    // Klarna has no en-cz page; redirects to the Czech (cs-cz) terms
    klarnaShoppingServiceLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/cs-cz/user',
    klarnaPrivacyPolicyLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/cs-cz/privacy',
  },
  en_de: {
    storedCredentialsConsentAgreement:
      'https://media.nuskin.com/asset/d5c5ffb7-873b-4ee9-81e8-fc004da5386f/Stored-credentials_EUA_en.pdf',
    klarnaShoppingServiceLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/en-de/user',
    klarnaPrivacyPolicyLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/en-de/privacy',
  },
  en_dk: {
    storedCredentialsConsentAgreement:
      'https://media.nuskin.com/asset/d5c5ffb7-873b-4ee9-81e8-fc004da5386f/Stored-credentials_EUA_en.pdf',
    // Klarna has no en-dk page; redirects to the Danish (da-dk) terms
    klarnaShoppingServiceLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/da-dk/user',
    klarnaPrivacyPolicyLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/da-dk/privacy',
  },
  en_es: {
    storedCredentialsConsentAgreement:
      'https://media.nuskin.com/asset/d5c5ffb7-873b-4ee9-81e8-fc004da5386f/Stored-credentials_EUA_en.pdf',
    klarnaShoppingServiceLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/en-es/user',
    klarnaPrivacyPolicyLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/en-es/privacy',
  },
  en_fi: {
    storedCredentialsConsentAgreement:
      'https://media.nuskin.com/asset/d5c5ffb7-873b-4ee9-81e8-fc004da5386f/Stored-credentials_EUA_en.pdf',
    klarnaShoppingServiceLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/en-fi/user',
    klarnaPrivacyPolicyLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/en-fi/privacy',
  },
  en_fr: {
    storedCredentialsConsentAgreement:
      'https://media.nuskin.com/asset/d5c5ffb7-873b-4ee9-81e8-fc004da5386f/Stored-credentials_EUA_en.pdf',
    klarnaShoppingServiceLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/en-fr/user',
    klarnaPrivacyPolicyLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/en-fr/privacy',
  },
  en_gb: {
    storedCredentialsConsentAgreement:
      'https://media.nuskin.com/asset/d5c5ffb7-873b-4ee9-81e8-fc004da5386f/Stored-credentials_EUA_en.pdf',
    klarnaShoppingServiceLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/en-gb/user',
    klarnaPrivacyPolicyLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/en-gb/privacy',
  },
  en_gr: {
    storedCredentialsConsentAgreement:
      'https://media.nuskin.com/asset/d5c5ffb7-873b-4ee9-81e8-fc004da5386f/Stored-credentials_EUA_en.pdf',
    klarnaShoppingServiceLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/en-gr/user',
    klarnaPrivacyPolicyLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/en-gr/privacy',
  },
  en_hu: {
    storedCredentialsConsentAgreement:
      'https://media.nuskin.com/asset/d5c5ffb7-873b-4ee9-81e8-fc004da5386f/Stored-credentials_EUA_en.pdf',
    // Klarna has no en-hu page; redirects to the Hungarian (hu-hu) terms
    klarnaShoppingServiceLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/hu-hu/user',
    klarnaPrivacyPolicyLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/hu-hu/privacy',
  },
  en_ie: {
    storedCredentialsConsentAgreement:
      'https://media.nuskin.com/asset/d5c5ffb7-873b-4ee9-81e8-fc004da5386f/Stored-credentials_EUA_en.pdf',
    klarnaShoppingServiceLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/en-ie/user',
    klarnaPrivacyPolicyLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/en-ie/privacy',
  },
  en_is: {
    storedCredentialsConsentAgreement:
      'https://media.nuskin.com/asset/d5c5ffb7-873b-4ee9-81e8-fc004da5386f/Stored-credentials_EUA_en.pdf',
  },
  en_it: {
    storedCredentialsConsentAgreement:
      'https://media.nuskin.com/asset/d5c5ffb7-873b-4ee9-81e8-fc004da5386f/Stored-credentials_EUA_en.pdf',
    klarnaShoppingServiceLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/en-it/user',
    klarnaPrivacyPolicyLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/en-it/privacy',
  },
  en_lu: {
    storedCredentialsConsentAgreement:
      'https://media.nuskin.com/asset/d5c5ffb7-873b-4ee9-81e8-fc004da5386f/Stored-credentials_EUA_en.pdf',
    // Klarna has no en-lu page; redirects to the French (fr-lu) terms
    klarnaShoppingServiceLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/fr-lu/user',
    klarnaPrivacyPolicyLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/fr-lu/privacy',
  },
  en_nl: {
    storedCredentialsConsentAgreement:
      'https://media.nuskin.com/asset/d5c5ffb7-873b-4ee9-81e8-fc004da5386f/Stored-credentials_EUA_en.pdf',
    // Klarna has no en-nl page; redirects to the Dutch (nl-nl) terms
    klarnaShoppingServiceLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/nl-nl/user',
    klarnaPrivacyPolicyLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/nl-nl/privacy',
  },
  en_no: {
    storedCredentialsConsentAgreement:
      'https://media.nuskin.com/asset/d5c5ffb7-873b-4ee9-81e8-fc004da5386f/Stored-credentials_EUA_en.pdf',
    // Klarna has no en-no page; redirects to the Norwegian (nb-no) terms
    klarnaShoppingServiceLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/nb-no/user',
    klarnaPrivacyPolicyLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/nb-no/privacy',
  },
  en_pl: {
    storedCredentialsConsentAgreement:
      'https://media.nuskin.com/asset/d5c5ffb7-873b-4ee9-81e8-fc004da5386f/Stored-credentials_EUA_en.pdf',
    // Klarna has no en-pl page; redirects to the Polish (pl-pl) terms
    klarnaShoppingServiceLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/pl-pl/user',
    klarnaPrivacyPolicyLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/pl-pl/privacy',
  },
  en_pt: {
    storedCredentialsConsentAgreement:
      'https://media.nuskin.com/asset/d5c5ffb7-873b-4ee9-81e8-fc004da5386f/Stored-credentials_EUA_en.pdf',
    // Klarna has no en-pt page; redirects to the Portuguese (pt-pt) terms
    klarnaShoppingServiceLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/pt-pt/user',
    klarnaPrivacyPolicyLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/pt-pt/privacy',
  },
  en_ro: {
    storedCredentialsConsentAgreement:
      'https://media.nuskin.com/asset/d5c5ffb7-873b-4ee9-81e8-fc004da5386f/Stored-credentials_EUA_en.pdf',
    // Klarna has no en-ro page; redirects to the Romanian (ro-ro) terms
    klarnaShoppingServiceLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/ro-ro/user',
    klarnaPrivacyPolicyLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/ro-ro/privacy',
  },
  en_se: {
    storedCredentialsConsentAgreement:
      'https://media.nuskin.com/asset/d5c5ffb7-873b-4ee9-81e8-fc004da5386f/Stored-credentials_EUA_en.pdf',
    // Klarna has no en-se page; redirects to the Swedish (sv-se) terms
    klarnaShoppingServiceLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/sv-se/user',
    klarnaPrivacyPolicyLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/sv-se/privacy',
  },
  en_sk: {
    storedCredentialsConsentAgreement:
      'https://media.nuskin.com/asset/d5c5ffb7-873b-4ee9-81e8-fc004da5386f/Stored-credentials_EUA_en.pdf',
    klarnaShoppingServiceLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/en-sk/user',
    klarnaPrivacyPolicyLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/en-sk/privacy',
  },
  el_gr: {
    storedCredentialsConsentAgreement:
      'https://media.nuskin.com/asset/d5c5ffb7-873b-4ee9-81e8-fc004da5386f/Stored-credentials_EUA_en.pdf',
    klarnaShoppingServiceLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/el-gr/user',
    klarnaPrivacyPolicyLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/el-gr/privacy',
  },
  es_es: {
    storedCredentialsConsentAgreement:
      'https://media.nuskin.com/asset/9ceaa117-b31e-496b-bfc8-5741248e6230/Stored-credentials_EUA_es.pdf',
    klarnaShoppingServiceLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/es-es/user',
    klarnaPrivacyPolicyLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/es-es/privacy',
  },
  fi_fi: {
    storedCredentialsConsentAgreement:
      'https://media.nuskin.com/asset/45fdefe7-e000-4720-bc3d-8c70e0c09eca/Stored-credentials_EUA_fi.pdf',
    klarnaShoppingServiceLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/fi-fi/user',
    klarnaPrivacyPolicyLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/fi-fi/privacy',
  },
  fr_be: {
    storedCredentialsConsentAgreement:
      'https://media.nuskin.com/asset/810f509b-414c-486c-936c-f3db681fe4f6/Stored-credentials_EUA_fr.pdf',
    klarnaShoppingServiceLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/fr-be/user',
    klarnaPrivacyPolicyLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/fr-be/privacy',
  },
  fr_ch: {
    storedCredentialsConsentAgreement:
      'https://media.nuskin.com/asset/810f509b-414c-486c-936c-f3db681fe4f6/Stored-credentials_EUA_fr.pdf',
    klarnaShoppingServiceLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/fr-ch/user',
    klarnaPrivacyPolicyLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/fr-ch/privacy',
  },
  fr_fr: {
    storedCredentialsConsentAgreement:
      'https://media.nuskin.com/asset/810f509b-414c-486c-936c-f3db681fe4f6/Stored-credentials_EUA_fr.pdf',
    klarnaShoppingServiceLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/fr-fr/user',
    klarnaPrivacyPolicyLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/fr-fr/privacy',
  },
  fr_lu: {
    storedCredentialsConsentAgreement:
      'https://media.nuskin.com/asset/810f509b-414c-486c-936c-f3db681fe4f6/Stored-credentials_EUA_fr.pdf',
    klarnaShoppingServiceLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/fr-lu/user',
    klarnaPrivacyPolicyLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/fr-lu/privacy',
  },
  hu_hu: {
    storedCredentialsConsentAgreement:
      'https://media.nuskin.com/asset/38665e2b-6f34-4d2b-9911-bdef2d377223/Stored-credentials_EUA_hu.pdf',
    klarnaShoppingServiceLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/hu-hu/user',
    klarnaPrivacyPolicyLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/hu-hu/privacy',
  },
  it_ch: {
    storedCredentialsConsentAgreement:
      'https://media.nuskin.com/asset/192da0fc-68ae-40ce-b2fc-b72d18734f78/Stored-credentials_EUA_it.pdf',
    klarnaShoppingServiceLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/it-ch/user',
    klarnaPrivacyPolicyLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/it-ch/privacy',
  },
  it_it: {
    storedCredentialsConsentAgreement:
      'https://media.nuskin.com/asset/192da0fc-68ae-40ce-b2fc-b72d18734f78/Stored-credentials_EUA_it.pdf',
    klarnaShoppingServiceLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/it-it/user',
    klarnaPrivacyPolicyLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/it-it/privacy',
  },
  nl_be: {
    storedCredentialsConsentAgreement:
      'https://media.nuskin.com/asset/077c2215-888d-4582-b051-55ade372195d/Stored-credentials_EUA_nl.pdf',
    klarnaShoppingServiceLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/nl-be/user',
    klarnaPrivacyPolicyLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/nl-be/privacy',
  },
  nl_nl: {
    storedCredentialsConsentAgreement:
      'https://media.nuskin.com/asset/077c2215-888d-4582-b051-55ade372195d/Stored-credentials_EUA_nl.pdf',
    klarnaShoppingServiceLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/nl-nl/user',
    klarnaPrivacyPolicyLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/nl-nl/privacy',
  },
  no_no: {
    storedCredentialsConsentAgreement:
      'https://media.nuskin.com/asset/6fdf2fbd-6e60-44e4-960f-f224ae1d9720/Stored-credentials_EUA_no.pdf',
    // Klarna's Norwegian terms are published under the nb-no locale code
    klarnaShoppingServiceLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/nb-no/user',
    klarnaPrivacyPolicyLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/nb-no/privacy',
  },
  pl_pl: {
    storedCredentialsConsentAgreement:
      'https://media.nuskin.com/asset/6d146b90-9345-4096-9408-68796d27f487/Stored-credentials_EUA_pl.pdf',
    klarnaShoppingServiceLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/pl-pl/user',
    klarnaPrivacyPolicyLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/pl-pl/privacy',
  },
  pt_pt: {
    storedCredentialsConsentAgreement:
      'https://media.nuskin.com/asset/b03081c0-5116-4514-b2c2-06b731d7b033/Stored-credentials_EUA_pt.pdf',
    klarnaShoppingServiceLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/pt-pt/user',
    klarnaPrivacyPolicyLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/pt-pt/privacy',
  },
  ro_ro: {
    storedCredentialsConsentAgreement:
      'https://media.nuskin.com/asset/82f18a37-aa2c-417d-9d0e-c36b8313b296/Stored-credentials_EUA_ro.pdf',
    klarnaShoppingServiceLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/ro-ro/user',
    klarnaPrivacyPolicyLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/ro-ro/privacy',
  },
  sk_sk: {
    storedCredentialsConsentAgreement:
      'https://media.nuskin.com/asset/13be06a2-fd64-41f8-ab84-c6ad56e0e04f/Stored-credentials_EUA_sk.pdf',
    klarnaShoppingServiceLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/sk-sk/user',
    klarnaPrivacyPolicyLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/sk-sk/privacy',
  },
  sv_fi: {
    storedCredentialsConsentAgreement:
      'https://media.nuskin.com/asset/e4a1c69e-3ff9-40b4-8c2c-ff2e25483c0a/Stored-credentials_EUA_sv.pdf',
    klarnaShoppingServiceLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/sv-fi/user',
    klarnaPrivacyPolicyLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/sv-fi/privacy',
  },
  sv_se: {
    storedCredentialsConsentAgreement:
      'https://media.nuskin.com/asset/e4a1c69e-3ff9-40b4-8c2c-ff2e25483c0a/Stored-credentials_EUA_sv.pdf',
  },
  en_au: {
    storedCredentialsConsentAgreement:
      'https://media.nuskin.com/m/45d952f6d9a7ba1a/original/Stored-Credentials-Consent.pdf',
    smsAgreement:
      'https://media.nuskin.com/m/0560501de5ad3c0a/original/sms-agreement-au.pdf',
    klarnaShoppingServiceLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/en-au/user',
    klarnaPrivacyPolicyLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/en-au/privacy',
  },
  en_nz: {
    storedCredentialsConsentAgreement:
      'https://media.nuskin.com/m/45d952f6d9a7ba1a/original/Stored-Credentials-Consent.pdf',
    klarnaShoppingServiceLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/en-nz/user',
    klarnaPrivacyPolicyLink:
      'https://cdn.klarna.com/1.0/shared/content/legal/terms/en-nz/privacy',
  },
  fr_pf: {
    storedCredentialsConsentAgreement:
      'https://media.nuskin.com/m/45d952f6d9a7ba1a/original/Stored-Credentials-Consent.pdf',
  },
  fr_nc: {
    storedCredentialsConsentAgreement:
      'https://media.nuskin.com/m/45d952f6d9a7ba1a/original/Stored-Credentials-Consent.pdf',
  },
}

export const SMS_TERMS_US =
  'https://www.nuskin.com/content/dam/account/north-america/US/en/SMS-Terms-of-Service_en_US.pdf'

export const SMS_TERMS_CA =
  'https://www.nuskin.com/content/dam/account/north-america/CA/en/CA_SMS-Terms-of-Service.pdf'

export const SMS_TERMS_AU =
  'https://media.nuskin.com/m/0560501de5ad3c0a/original/sms-agreement-au.pdf'

export const GLOBAL_PRIVACY_LINK =
  'https://www.nuskin.com/content/global-privacy.html'
